module.exports = __webpack_public_path__ + "static/media/green1.65332615.png";